import { ALL_STORE } from "constants/DashboardContanst";
import { errorMessage } from "helpers/utils";
import { call, put, select, takeEvery } from "redux-saga/effects";
import signMethodService from "services/SignMethodService";
import {
  CREATE_LIST_SIGN_METHOD,
  CREATE_SIGN_METHOD,
  DELETE_SIGN_METHOD,
  EDIT_SIGN_METHOD,
  GET_ALL_SIGN_METHOD,
  GET_DETAIL_SIGN_METHOD,
  GET_LIST_SIGN_METHOD,
  GET_LIST_VAT,
} from "./actionTypes";
import {
  createListSignMethodFail,
  createListSignMethodSuccess,
  createSignMethodFail,
  createSignMethodSuccess,
  deleteSignMethodFail,
  deleteSignMethodSuccess,
  editSignMethodFail,
  editSignMethodSuccess,
  getAllSignMethodFail,
  getAllSignMethodSuccess,
  getDetailSignMethodFail,
  getDetailSignMethodSuccess,
  getListSignMethodFail,
  getListSignMethodSuccess,
  getListVatFail,
  getListVatSuccess,
} from "./actions";

function* fetchGetSignMethod({ params }) {
  try {
    const perPage = params.sizePerPage;
    const page = params.page;
    const columnFilter = params.columnFilter;
    const keywords = params.keywords;
    const sort = params.sort;

    //
    let { finalListBuCode, listBuOfTenant, buStoreHeader, buTenantHeaderInfo } =
      yield select(state => state.Dashboard);
    let bu_parent = undefined;
    let bu_code = undefined;
    if (buStoreHeader === ALL_STORE) {
      bu_code = buTenantHeaderInfo.code;
    } else {
      bu_code = buStoreHeader;
    }
    // Call api
    const response = yield call(
      signMethodService.listItems,
      page,
      perPage,
      columnFilter,
      keywords,
      sort,
      bu_code,
      bu_parent
    );
    const totalCount = response._meta.totalCount;
    yield put(getListSignMethodSuccess(response.items, totalCount));
  } catch (error) {
    yield put(getListSignMethodFail(errorMessage(error)));
  }
}

function* fetchGetDetailSignMethod({ id }) {
  try {
    const response = yield call(signMethodService.detailItems, id);
    // console.log("response", response);
    yield put(getDetailSignMethodSuccess(response));
  } catch (error) {
    yield put(getDetailSignMethodFail(errorMessage(error)));
  }
}

function* fetchCreateSignMethod({ data }) {
  try {
    const response = yield call(signMethodService.createItems, data);
    yield put(createSignMethodSuccess(response));
  } catch (error) {
    yield put(createSignMethodFail(errorMessage(error)));
  }
}

function* fetchCreateListSignMethod({ data }) {
  try {
    let response = null;
    if (data && data.length > 0) {
      response = yield call(signMethodService.createListItems, data);
    }
    yield put(createListSignMethodSuccess(response));
  } catch (error) {
    yield put(createListSignMethodFail(errorMessage(error)));
  }
}

function* fetchEditSignMethod({ data, id }) {
  try {
    const response = yield call(signMethodService.editItems, data, id);
    yield put(editSignMethodSuccess(response));
  } catch (error) {
    yield put(editSignMethodFail(errorMessage(error)));
  }
}

function* fetchDeleteSignMethod({ id }) {
  try {
    const response = yield call(signMethodService.deleteItems, id);
    // Wait XML generate
    yield put(deleteSignMethodSuccess(response));
  } catch (error) {
    yield put(deleteSignMethodFail(errorMessage(error)));
  }
}

function* fetchGetListVat({}) {
  try {
    const response = yield call(signMethodService.listVats);
    const listVat = response.items.map(item => {
      return {
        value: item.id,
        label: item.ltsuat,
        id: item.id,
        vat_text: null,
      };
    });
    yield put(getListVatSuccess(listVat));
  } catch (error) {
    yield put(getListVatFail(errorMessage(error)));
  }
}

function* fetchGetAllProduct({}) {
  try {
    const response = yield call(signMethodService.listAllProduct);
    const list = response.items.map(item => {
      return {
        ...item,
        value: item.name,
        label: item.code + " - " + item.name,
      };
    });
    yield put(getAllSignMethodSuccess(list));
  } catch (error) {
    yield put(getAllSignMethodFail(errorMessage(error)));
  }
}

function* signMethodSaga() {
  yield takeEvery(GET_LIST_SIGN_METHOD, fetchGetSignMethod);
  yield takeEvery(GET_DETAIL_SIGN_METHOD, fetchGetDetailSignMethod);
  yield takeEvery(CREATE_SIGN_METHOD, fetchCreateSignMethod);
  yield takeEvery(CREATE_LIST_SIGN_METHOD, fetchCreateListSignMethod);
  yield takeEvery(EDIT_SIGN_METHOD, fetchEditSignMethod);
  yield takeEvery(DELETE_SIGN_METHOD, fetchDeleteSignMethod);

  yield takeEvery(GET_LIST_VAT, fetchGetListVat);
  yield takeEvery(GET_ALL_SIGN_METHOD, fetchGetAllProduct);
}

export default signMethodSaga;
